import { Sparkles } from "lucide-react";

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-yellow-50 py-16 sm:py-20">
    <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">
      <div className="relative">
        <img
          src="https://images.unsplash.com/photo-1606092195730-5d7b9af1efc5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
          alt="Children playing together with a colorful parachute at day camp"
          className="rounded-[2rem] border-4 border-teal-400 shadow-pop-teal w-full object-cover aspect-[4/3]"
        />
        <div className="absolute -bottom-5 -right-3 bg-pink-500 text-white font-display font-bold px-5 py-3 rounded-2xl rotate-3 shadow-pop text-sm sm:text-base">
          Play • Learn • Grow!
        </div>
      </div>
      <div>
        <div className="inline-flex items-center gap-2 bg-teal-400/20 text-teal-700 font-display font-bold px-4 py-1.5 rounded-full mb-4">
          <Sparkles className="w-4 h-4" /> About Our Camp
        </div>
        <h2 className="font-display font-bold text-pink-500 text-4xl sm:text-5xl leading-tight">
          A place where kids shine
        </h2>
        <p className="mt-5 text-emerald-950 font-medium text-lg leading-relaxed">
          WonderStarzLV Day Camp brings hands-on learning and joyful play to families across
          Las Vegas. We rotate through welcoming community library locations, giving your child
          a safe, nurturing space to explore science, art, and friendship.
        </p>
        <p className="mt-4 text-emerald-800 font-medium text-lg leading-relaxed">
          Every day is packed with curiosity-sparking activities designed to build confidence,
          creativity, and unforgettable memories.
        </p>
      </div>
    </div>
  </section>
);
